import React, {useEffect, useState} from 'react'
import { getCurrentUser } from '../utils/auth'
import {format} from 'date-fns'
// import "./Facilities.css"
import "./Pods.css"
import { useNavigate } from "react-router-dom"
import { BsFillPencilFill, BsFillTrashFill, BsFileTextFill, BsTable, BsController } from 'react-icons/bs'
import ModalPodEdit from "./ModalPodEdit"
import ModalPodSessions from './ModalPodSessions'
import ModalPodNotes from './ModalPodNotes'
import ModalPodControl from './ModalPodControl'
import ModalPodErrorLogs from './ModalPodErrorLogs'
import Caret from './Icon/Caret'
import { Link } from 'react-router-dom'

const Facilities = ({deleteRow}) => {
    const tokenPayload = getCurrentUser() || {};
    const userScopes = tokenPayload.scopes || [];
    const navigate = useNavigate();
    const permissionScope = 'podData'
    const tokenCustomerId = tokenPayload?.customer ?? tokenPayload?.customer_id;
    const hasGlobalReadPermission = userScopes.includes('read:' + permissionScope);
    const hasCustomerScopedReadPermission = userScopes.some((scope) => scope.startsWith('read:' + permissionScope + 'Customer'));
    const hasReadPermission = hasGlobalReadPermission || hasCustomerScopedReadPermission;
    const shouldFilterByCustomer = Boolean(tokenCustomerId !== undefined && tokenCustomerId !== null && hasCustomerScopedReadPermission && !hasGlobalReadPermission);
    const fetchAllPodsUrl = process.env.REACT_APP_API_URL_BASE + '/machines/view'
    const fetchCustomerPodsUrl = process.env.REACT_APP_API_URL_BASE + '/machines/customer/*id*/view'
    const fetchSinglePodUrl = process.env.REACT_APP_API_URL_BASE + '/machines/machine/*id*/view'
    const fieldsNoSort = ["Info", "Authorized", "Actions"]
    const headers = [
        {
            id: 0,
            KEY: "info",
            LABEL: "Info",
            CLASS: "icons-width"
        },
        {
            id: 1,
            KEY: "id",
            LABEL: "ID",
            CLASS: "left"
        },
        {
            id: 2,
            KEY: "description",
            LABEL: "Pod Description",
            CLASS: "left"
        },
        {
            id: 3,
            KEY: "machine_type_description",
            LABEL: "Type",
            CLASS: "left"
        },
        {
            id: 4,
            KEY: "customer_name",
            LABEL: "Customer",
            CLASS: "left"
        },
        {
            id: 5,
            KEY: "facility_name",
            LABEL: "Facility",
            CLASS: "left"
        },
        {
            id: 6,
            KEY: "is_authorized",
            LABEL: "Authorized",
            CLASS: ""
        },
        {
            id: 7,
            KEY: "created_on",
            LABEL: "Pod Since",
            CLASS: "left"
        },
        {
            id: 8,
            KEY: "serial_tag",
            LABEL: "Serial Tag",
            CLASS: ""
        },
        {
            id: 9,
            KEY: "actions",
            LABEL: "Actions",
            CLASS: "left"
        }
    ]

    const [podEdit, setPodEdit] = useState(null);
    const [podControlInfo, setPodControlInfo] = useState(null);
    const [podIdSessions, setPodIdSessions] = useState(null);
    const [podInfo, setPodInfo] = useState(null);
    const [allPodTypes, setAllPodTypes] = useState(null);
    const [allCustomers, setAllCustomers] = useState([]);
    const [editedRecord, setEditedRecord] = useState(null);
    const [isNewPod, setIsNewPod] = useState(false);
    const [modalNotes, setModalNotes] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [isReadOnlyModal, setIsReadOnlyModal] = useState(false);
    const [modalSessions, setModalSessions] = useState(false);
    const [modalPodControl, setModalPodControl] = useState(false);
    const [isPodErrorSummaryModalOpen, setIsPodErrorSummaryModalOpen] = useState(false);
    const [sessionCount] = useState(0);
    const [thisCustomerId, setThisCustomerId] = useState(null);
    const [customerFacilities, setCustomerFacilities] = useState(null);
    const [records, setRecords] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [showUnauthorized, setShowUnauthorized] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [sort, setSort] = useState({ keyToSort: "customer", direction: "asc"});

    const normalizedSearchText = searchText.trim().toLowerCase();

    const matchesSearch = (record) => {
        if (!normalizedSearchText) {
            return true;
        }

        const searchableValues = [
            record.id,
            record.description,
            record.machine_type_description,
            record.customer_name,
            record.facility_name,
            record.serial_tag,
        ];

        return searchableValues
            .filter((value) => value !== null && value !== undefined)
            .some((value) => String(value).toLowerCase().includes(normalizedSearchText));
    };

    const visibleRecords = records
        .map((record, recordIndex) => ({ record, recordIndex }))
        .filter(({ record }) => (showUnauthorized || record.is_authorized !== false) && matchesSearch(record));

    const truncateDescription = (description) => {
        const text = String(description ?? '').replace(/\s+/g, ' ').trim();
        return text.length > 50 ? `${text.slice(0, 47)}...` : text;
    };


    const fetchAllPodData = async () => {
        setIsTableLoading(true);
        try{
            const response = await fetch(fetchAllPodsUrl,
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(json);
        } catch (error) {
            console.error(error);
        } finally {
            setIsTableLoading(false);
        }
    }

    const fetchCustomerPodData = async (customer_id) => {
        setIsTableLoading(true);
        try{
            const response = await fetch(fetchCustomerPodsUrl.replace("*id*", customer_id),
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(json);
        } catch (error) {
            console.error(error);
        } finally {
            setIsTableLoading(false);
        }
    }

    const fetchSinglePodData = async (pod_id) => {
        try{
            const response = await fetch(fetchSinglePodUrl.replace("*id*", pod_id),
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(originalRecords => {
                const newRecords = [...originalRecords];
                newRecords[editedRecord] = json[0];
                return newRecords;
            });
        } catch (error) {
            console.error(error);
        }
    }

    const fetchAllPodTypes = async () => {
        fetch(process.env.REACT_APP_API_URL_BASE + '/machine_types/',
        {
            method: 'GET',
            headers: {
                'machine':'2',
                'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
            },
        })
        .then(res => res.json())
        .then(data => {
            const podTypes = data.map(item => ({ description: item.description, id: item.machine_type_id }));
            setAllPodTypes(podTypes)
        })
        .catch(error => console.error(error));
    }

    const fetchAllCustomers = async () => {
            fetch(process.env.REACT_APP_API_URL_BASE + '/customers/',
            {
                method: 'GET',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                },
            })
            .then(res => res.json())
            .then(data => {
                const formattedCustomers = data.map(item => ({ customer_name: item.customer_name, id: item.customer_id }));
                setAllCustomers(formattedCustomers)
            })
            .catch(error => console.error(error));
        }

    async function apiGetCustomerFacilities(customer_id) {
        try{
            const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/facilities/customer/' + customer_id + '/view',
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            return json
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (!window.sessionStorage.getItem("auth") || !hasReadPermission) {
            navigate('/unauthorized')
        }

        if (editedRecord !== null) {
            fetchSinglePodData(records[editedRecord].id);
            setEditedRecord(null)
        }
        else {
            if (shouldFilterByCustomer) {
                //pull only pods attached to this users customer ID
                fetchCustomerPodData(tokenCustomerId);
            }
            else {
                // pull all Facilities
                fetchAllPodData();
            }
        }
        fetchAllPodTypes();
        fetchAllCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleHeaderClick(header) {
        if (!fieldsNoSort.includes(header.LABEL)) {
            const nextDirection =
                header.KEY === sort.keyToSort
                    ? (sort.direction === 'asc' ? 'desc' : 'asc')
                    : 'asc';

            const nextSort = {
                keyToSort: header.KEY,
                direction: nextDirection,
            };

            setSort(nextSort);
            setRecords((originalRecords) => {
                const sortedData = [...originalRecords].sort((a, b) => {
                    const aValue = a[nextSort.keyToSort];
                    const bValue = b[nextSort.keyToSort];

                    if (aValue === null || aValue === undefined) return 1;
                    if (bValue === null || bValue === undefined) return -1;

                    const aComparable = String(aValue).toLowerCase();
                    const bComparable = String(bValue).toLowerCase();

                    if (nextSort.direction === 'asc') {
                        return aComparable.localeCompare(bComparable);
                    }

                    return bComparable.localeCompare(aComparable);
                });

                return sortedData;
            });
        }
    }

    const handlePodEdit = async (podInfo, recordIndex) => {
        // edit pod info icon clicked
        // set the record in order to do a refresh on the edited pod
        setCustomerFacilities(await apiGetCustomerFacilities(podInfo.customer_id))
        setThisCustomerId(podInfo.customer_id)
        setEditedRecord(recordIndex)
        setPodEdit(podInfo)
        setIsNewPod(false);
        setIsReadOnlyModal(false);
        setModalEdit(true);
      };

    const handlePodView = async (podInfo, event) => {
        if (event.target.closest('.actions-cell') || event.target.closest('.info-cell')) {
            return;
        }

        setCustomerFacilities(await apiGetCustomerFacilities(podInfo.customer_id))
        setThisCustomerId(podInfo.customer_id)
        setPodEdit(podInfo)
        setIsNewPod(false);
        setIsReadOnlyModal(true);
        setModalEdit(true);
    };

    const handleViewSessions = (podInfo) => {
        // View Sessions icon clicked
        setIsNewPod(false);
        setPodInfo(podInfo);
        setPodIdSessions(podInfo.id);
        setModalSessions(true);
    }

    const handlePodControl = (podInfo) => {
        // Pod Control icon clicked
        setModalPodControl(true);
        setPodControlInfo(podInfo);
        // console.log("Pod Control Info: ", podInfo);
    }

    const handleViewNotes = (podInfo) => {
        // Notes icon clicked
        setIsNewPod(false);
        setPodInfo(podInfo);
        setModalNotes(true);
    }

    const handleDeletePod = async (podInfo, recordIndex) => {
        // Delete icon clicked: set pod unauthorized
        if (canDeleteRecords) {
            try {
                const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/machines/machine/' + podInfo.id,
                    {
                        method: 'PATCH',
                        headers: {
                            'machine':'2',
                            'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            is_authorized: false
                        }),
                    });

                if (!response.ok) {
                    throw new Error(`Failed to set pod unauthorized. Status: ${response.status}`);
                }

                setRecords((originalRecords) => originalRecords.map((record, index) => {
                    if (index !== recordIndex) {
                        return record;
                    }

                    return {
                        ...record,
                        is_authorized: false,
                    };
                }));
            } catch (error) {
                console.error(error);
            }
        }
    }

    const handleNewPod = async () => {
        // new pod button clicked - create a generic empty pod object
        setCustomerFacilities(await apiGetCustomerFacilities(0));
        setPodEdit(null);
        setIsNewPod(true);
        setModalEdit(true);
      }

    const handleEditSubmit = (newRow) => {
        if (isNewPod) {
            // pull all data - refresh page
            window.location.reload()
            setIsNewPod(false)
        }
        else {
            // edited existing pod - update specific row
            fetchSinglePodData(records[editedRecord].id)
            setEditedRecord(null)
        }
      }

    const handleNotesSubmit = () => {
        //  handle any necessary logic after a new has been added
    }

    const showDelete = (record, recordIndex) => {
        // if the user has delete scope then show the delete icon
        if (canDeleteRecords) {
            return <BsFillTrashFill onClick={() => handleDeletePod(record, recordIndex)} className='delete-btn' title='Deauthorize this Pod' aria-label='Deauthorize this Pod'/>
        }
    }

    const showEdit = (record, recordIndex) => {
        // if the user has edit scope then show the edit icon
        if (canEditRecords) {
            return <BsFillPencilFill onClick={() => handlePodEdit(record,recordIndex)} className='edit-btn' title='Edit Pod' aria-label='Edit Pod'/>
        }
    }

    const hasNotesPermission = (tokenPayload.scopes || []).some((scope) =>
        scope.startsWith('create:podNotes') || scope.startsWith('update:podNotes')
    );
    const currentUserTypeId = Number(tokenPayload?.user_type_id ?? tokenPayload?.user_type);
    const normalizedUserTypeDescription = String(tokenPayload?.user_type_description ?? tokenPayload?.description ?? '').toLowerCase();
    const canViewPodErrorSummary = currentUserTypeId >= 10 || normalizedUserTypeDescription.includes('creator');

    const canDeleteRecords =
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('delete:' + permissionScope));

    const canEditRecords =
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('update:' + permissionScope)) ||
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('create:' + permissionScope));

    const canShowAnyActions = canDeleteRecords || canEditRecords;
    const visibleHeaders = canShowAnyActions ? headers : headers.filter((header) => header.KEY !== 'actions');
    const canShowUnauthorizedToggle = canDeleteRecords;

    const showCreateNew = () => {
        // if the user has create scope then show the Add New Pod button
        if ((tokenPayload.scopes || []).some((scope) => scope.startsWith('create:' + permissionScope))) {
            return (
                <Link className='btn pods-add-btn' onClick={() => handleNewPod()}>+ Add New Pod</Link>
            )
        }
    }

    const canUsePodControl = (tokenPayload.scopes || []).includes('allow:podControl');

    function showDebug() {
        // var debugString = 'Sort Direction: ' + sort.direction + ' Sort Field: ' + sort.keyToSort;
        // // var debugString = sort.keyToSort === 'last_name' ? sort.direction : "asc"
        // return debugString
    }

    return (
        <div className='table-wrapper pods-page'>
            {/*<h3 className='left'>&emsp;&ensp;Facilities{podInfo !== null ? ": " + podInfo.pod_name : ""} ({records.length})</h3>*/}
            <h3 className='page-title'>
                Pods <span className='page-count'>{visibleRecords.length}</span>
            </h3>
            <div>
                {showDebug()}
            </div>
            <div>
                {showCreateNew()}
            </div>
            <div className='pods-filter'>
                <div className='table-search-input-wrap'>
                    <input
                        type='text'
                        className='pods-search-input table-search-input'
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                        placeholder='Search pods'
                        aria-label='Search pods'
                    />
                    <button
                        type='button'
                        className='table-search-clear-icon'
                        onClick={() => setSearchText('')}
                        disabled={!searchText}
                        aria-label='Clear pod search'
                    >
                        x
                    </button>
                </div>
                {canShowUnauthorizedToggle && (
                    <label className='pods-filter-label'>
                        <input
                            type='checkbox'
                            checked={showUnauthorized}
                            onChange={(event) => setShowUnauthorized(event.target.checked)}
                        />
                        Show Unauthorized
                    </label>
                )}
                {canViewPodErrorSummary && (
                    <button
                        type='button'
                        className='pods-error-log-btn'
                        onClick={() => setIsPodErrorSummaryModalOpen(true)}
                    >
                        View Pod Error Log
                    </button>
                )}
            </div>
            <font size="3">
            <table className='table'>
                <thead>
                    <tr>
                        {visibleHeaders.map((header, index) => (
                            <th key={index} className={header.CLASS} onClick={() => handleHeaderClick(header)}>
                                {header.LABEL}
                                {header.KEY === sort.keyToSort && (
                                <Caret direction={sort.keyToSort === header.KEY ? sort.direction : "asc"}/>)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {
                        isTableLoading ? (
                            Array.from({ length: 6 }).map((_, rowIndex) => (
                                <tr key={`pods-skeleton-${rowIndex}`} className='table-skeleton-row'>
                                    {visibleHeaders.map((header, cellIndex) => (
                                        <td key={`pods-skeleton-${rowIndex}-${header.KEY}-${cellIndex}`}>
                                            <span className={`table-skeleton-line${header.KEY === 'info' || header.KEY === 'actions' ? ' short' : ''}`} />
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            visibleRecords.map(({ record, recordIndex }) => {
                                return <tr key={recordIndex} onClick={(event) => handlePodView(record, event)}>
                                <td className='info-cell'>
                                    <span className='actions actions-three'>
                                        {hasNotesPermission && (
                                            <BsFileTextFill onClick={(event) => { event.stopPropagation(); handleViewNotes(record); }} className='sessions-btn' title='Pod Notes' aria-label='Pod Notes'/>
                                        )}
                                        <BsTable onClick={(event) => { event.stopPropagation(); handleViewSessions(record); }} className='sessions-btn' title='Show Session History' aria-label='Show Session History'/>
                                        {canUsePodControl && (
                                            <BsController onClick={(event) => { event.stopPropagation(); handlePodControl(record); }} className='sessions-btn' title='Pod Controls' aria-label='Pod Controls'/>
                                        )}
                                    </span>
                                </td>
                                <td className='left'>{record.id}</td>
                                <td className='left pods-description-cell' title={record.description ?? ''}>{truncateDescription(record.description)}</td>
                                <td className='left'>{record.machine_type_description}</td>
                                <td className='left'>{record.customer_name}</td>
                                <td className='left'>{record.facility_name}</td>
                                <td className='center'>{record.is_authorized ? "\u2714" : ""}</td>
                                <td className='left'>{record.created_on ? format(new Date(record.created_on), 'MMM d, yyyy') : ''}</td>
                                <td className='center'>{record.serial_tag}</td>
                                {canShowAnyActions && (
                                    <td className='actions-cell'>
                                        <span className='actions'>
                                            {showEdit(record, recordIndex)}
                                            {showDelete(record, recordIndex)}
                                        </span>
                                    </td>
                                )}
                            </tr>
                            })
                        )}
                </tbody>
            </table>
            </font>
            {modalEdit && <ModalPodEdit closeModal={() => {
                setModalEdit(false)
                setIsReadOnlyModal(false)
            }}
                onSubmit={handleEditSubmit}
                podEdit={podEdit}
                isNewPod={isNewPod}
                allPodTypes={allPodTypes}
                allCustomers={allCustomers}
                thisCustomerId={thisCustomerId}
                thisCustomerFacilities={customerFacilities}
                isReadOnly={isReadOnlyModal}
            />}
            {modalSessions && <ModalPodSessions closeModal={() => {
                setModalSessions(false)
            }}
                podIdSessions={podIdSessions}
                podInfo={podInfo}
                sessionCount={sessionCount}
            />}
            {modalPodControl && <ModalPodControl closeModal={() => {
                setModalPodControl(false)
            }}
                podData={podControlInfo}
            />}
            {modalNotes && <ModalPodNotes closeModal={() => {
                setModalNotes(false)
            }}
                onSubmit={handleNotesSubmit}
                podInfo={podInfo}
                isNewPod={isNewPod}
            />}
            {isPodErrorSummaryModalOpen && <ModalPodErrorLogs closeModal={() => {
                setIsPodErrorSummaryModalOpen(false)
            }}
                mode='summary'
            />}
        </div>
  )
}

export default Facilities



